import { UPCISO } from "@/lib/breach/upciso"

/** Labeled, modest pointer to upCISO. Carries only attribution tags; nothing about the person or incident. */
export function UpcisoCard({ heading = "Turn this into a security roadmap" }: { heading?: string }) {
  return (
    <section className="rounded-lg border border-border bg-card p-4 text-sm print:hidden" aria-labelledby="upciso-h">
      <h3 id="upciso-h" className="text-base font-semibold">{heading}</h3>
      <p className="mt-2 text-muted-foreground">{UPCISO.blurb}</p>
      <p className="mt-2 text-muted-foreground">{UPCISO.limits} {UPCISO.independence}</p>
      <p className="mt-3 flex flex-wrap gap-x-5 gap-y-1">
        <a className="font-medium underline" href={UPCISO.home} target="_blank" rel="sponsored noopener">Visit upCISO (InventiveHQ)</a>
        <a className="underline" href={UPCISO.demo} target="_blank" rel="sponsored noopener">See the demo</a>
        <a className="underline" href={UPCISO.tools} target="_blank" rel="sponsored noopener">Free tools</a>
      </p>
    </section>
  )
}
